export interface LayoutModel {
  isSlim?: boolean;
  isMobile?: boolean;
  isDesktop?: boolean;
  menuHoverActive?: boolean;
  staticMenuMobileActive?: boolean;
}
